import styles from "./SecondaryInfoCard.module.scss";
import { ButtonCust } from "../../widgets";
import Config from "../../../config/env.config.json";
import { Box, Grid } from "@mui/material";
import { BrandNameUpdate } from "../../../utils/commonFunctions/BrandNameUpdate";
import { useAppSelector } from "../../../app/hooks";

type initialProps = {
  is_right?: boolean;
  image: any;
  info: string;
  title: string;
  onclick?: any;
  btnTxt?: string;
  btnTxt1?: string;
  maxImgWidth?: string;
  maxImgHeight?: string;
  btnWidth?: string;
  btn1Width?: string;
  subInfo?: string;
  onClick2?: any;
  alt?: string;
  className?: string;
  isSecondSecondary?: boolean;
};

export const SecondaryInfoCard = (props: initialProps) => {
  const { subDomainData } = useAppSelector((state: any) => state?.homepage);
  return (
    <Grid
      container
      sx={{
        // pl: { sm: "30px" },
        // pr: { sm: "100px" },
        // px: { sm: 8 },
        py: { sm: 10 },
        display: "flex",
        justifyContent:'center',
        flexDirection: {
          xs: "row",
          md: props.is_right ? "row-reverse" : "row",
        },
      }}
      className={props.className ? props.className : ""}
      gap={{ xs: 3 }}
      // gap={{ xs: 3, md: 3, lg: 0 }}
    >
      <Grid item md={8} xs={12} display="flex" flexDirection={{ xs: 'column', sm: 'row' }} justifyContent={'space-between'}>
        <Grid
          item
          container
          xs={12}
          md={12}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            textAlign: "center",
          }}
        >
          <Grid
          item
          xs={12}
          md={4}
          sx={{
            display: {xs: "none", sm: "flex"},
            alignItems: "center",
            justifyContent: "center",
            // padding: { xs: "10px", md: "0px 57px" },
            padding: { xs: "10px", sm: '0px', md: '0px' },
          }}
        >
          <img
            src={
              subDomainData?.data?.smallImage2Url
                ? subDomainData?.data?.smallImage2Url
                : props.image
            }
            style={{
              maxHeight: props.maxImgHeight ? props.maxImgHeight : "",
              maxWidth: props.maxImgWidth ? props.maxImgWidth : "",
            }}
            className={styles.img_container}
            alt={props.alt ? BrandNameUpdate(props.alt) : ""}
          />
        </Grid>
          <Grid
            item
            container
            xs={12}
            md={6}
            // lg={11}
            sx={{
              px: {xs: 2, md: 0},
              py: { xs: 0.5, md: 2 },
              display: "flex",
              justifyContent: { xs: "center", md: "start" },
              flexDirection: "column",
              alignItems: { xs: "center", md: "start" },
              maxWidth: {sm: '395px'}
            }}
          >
            <Box
              className={styles.infocard_detail_title}
              sx={{
                textAlign: { xs: "center", md: "left" },
                fontSize: { xs: "26px", sm: "30px" },
                color: "var(--black)",
                fontWeight: "var(--font_weight_4)",
              }}
            >
              {props.title}
            </Box>
            <Box
              sx={{ textAlign: { xs: "center", md: "start" }, fontSize: "14px" }}
              className={styles.infocard_detail_data}
            >
              {BrandNameUpdate(props.info)}
            </Box>
            {props.subInfo && (
              <Box className={styles.infocard_detail_subdata}>
                {props.subInfo}
              </Box>
            )}

            {/* <Box className={styles.infocard_detail_btn}>
            <Box
              className={styles.infocard_detail_btn1}
              style={{ width: props.btnWidth ? props.btnWidth : "" }}
            > */}
            {props.btnTxt && (
              <ButtonCust
                // className={styles.infocard_detail_btn1}
                variantType={Config.PRIMARY_BUTTON_TYPE}
                onClick={props.onclick}
                sx={{
                  width: "250px",
                  // position: "relative",
                  display: "flex",
                  margin: { xs: "auto", md: "0" },
                }}
              >
                {props.btnTxt}
              </ButtonCust>
            )}
            {/* </Box>
            <Box
              className={styles.infocard_detail_btn2}
              style={{ width: props.btnWidth ? props.btnWidth : "" }}
            > */}
            {props.btnTxt1 && (
              <ButtonCust
                className={styles.infocard_detail_btn2}
                variantType={Config.PRIMARY_BUTTON_TYPE}
                onClick={props.onClick2}
              >
                {props.btnTxt1}
              </ButtonCust>
            )}
            {/* </Box>
          </Box> */}
          </Grid>
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
          sx={{
            display: {xs: "flex", sm: "none"},
            alignItems: "center",
            justifyContent: "center",
            // padding: { xs: "10px", md: "0px 57px" },
            padding: { xs: "25px 10px 10px 10px" },
          }}
        >
          <img
            src={
              subDomainData?.data?.smallImage2Url
                ? subDomainData?.data?.smallImage2Url
                : props.image
            }
            style={{
              maxHeight: props.maxImgHeight ? props.maxImgHeight : "",
              maxWidth: props.maxImgWidth ? props.maxImgWidth : "",
            }}
            className={styles.img_container}
            alt={props.alt ? BrandNameUpdate(props.alt) : ""}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};
